// import { configureStore } from "@reduxjs/toolkit";
import categoryReducer from "./category";
import cartReducer from "./cart";
import dishReducer from "./dish";
import drawerReducer from "./drawer";
import finalOrderReducer from "./finalOrder";
import orderReducer from "./order";
import restaurantReducer from "./restaurant";
import locationsReducer from "./locations";
import { configureStore, combineReducers } from "@reduxjs/toolkit";

// export const store = configureStore({
//   reducer: {
// cart: cartReducer,
// category: categoryReducer,
// dish: dishReducer,
// drawer: drawerReducer,
// finalOrder: finalOrderReducer,
// order: orderReducer,
// restaurant: restaurantReducer,
//   },
// });

const combinedReducer = combineReducers({
  cart: cartReducer,
  category: categoryReducer,
  dish: dishReducer,
  drawer: drawerReducer,
  finalOrder: finalOrderReducer,
  location: locationsReducer,
  order: orderReducer,
  restaurant: restaurantReducer,
});

const rootReducer = (state, action) => {
  if (action.type === "restaurant/logoutRestaurant") {
    state = undefined;
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("location");
  }
  return combinedReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
});
